import DataReference from './DataReference.js';
import DataReferenceResource from '../geodata/DataReferenceResource.js';
import DataReferenceQueryPatternType from './DataReferenceQueryPatternType.js';
import patterns from './patterns.js';
/**
 * @memberof data-references
 * @property {data-references.DataReferenceQueryPatternType} type
 * @property {data-references.CustomerQueryParameters|data-references.SystemQueryParameters} parameters
 */
class DataReferenceQuery {
    constructor({ type = null, parameters = {} } = {}) {
        this.type = type;
        if (this.pattern) {
            const PatternParameters = patterns.byPatternType[this.pattern];
            this.parameters = new PatternParameters(parameters);
        }
        else {
            this.parameters = parameters;
        }
    }
    /**
     * Forms consistent interface to {@linkcode feature-references.FeatureReferenceQuery}
     * @param {DataReferenceQueryPatternType} type
     * @private
     */
    set pattern(type) {
        this.type = type;
    }
    /**
     * Forms consistent interface to {@linkcode feature-references.FeatureReferenceQuery}
     * @type {DataReferenceQueryPatternType}
     */
    get pattern() {
        return this.type;
    }
    /**
     * Unique identifier for the parameters
     * @type {string}
     */
    get key() {
        return this.isEmpty ? '' : `${this.pattern}?${queryString(this.parameters)}`;
    }
    /**
     * @type {boolean}
     */
    get isEmpty() {
        return this.pattern === null;
    }
    /**
     * @type {boolean}
     */
    get hasParameters() {
        return Object.keys(this.parameters).length > 0;
    }
    /**
     * @return {Promise<DataReference[]>}
     */
    evaluate() {
        return DataReferenceResource.where({ type: this.pattern, ...this.parameters })
            .then((result) => result.map((props) => {
            const prop = props;
            return props && new DataReference(prop);
        }));
    }
    /**
     * @return {object}
     */
    toJSON() {
        return {
            type: this.type,
            parameters: this.parameters,
        };
    }
    /**
     * @param {data-references.SystemQueryParameters} parameters
     * @return {data-references.DataReferenceQuery}
     */
    static system(parameters) {
        return new DataReferenceQuery({
            type: DataReferenceQueryPatternType.SYSTEM,
            parameters,
        });
    }
    /**
     * @param {data-references.CustomerQueryParameters} parameters
     * @return {data-references.DataReferenceQuery}
     */
    static customer(parameters) {
        return new DataReferenceQuery({
            type: DataReferenceQueryPatternType.CUSTOMER,
            parameters,
        });
    }
}
/**
 */
DataReferenceQuery.PatternType = DataReferenceQueryPatternType;
/**
 */
DataReferenceQuery.patterns = patterns;
function queryString(fromParameters = {}) {
    const params = new URLSearchParams();
    Object.keys(fromParameters).sort().forEach((key) => {
        const value = fromParameters[key];
        if (Array.isArray(value)) {
            value.forEach((entry) => params.append(key, entry));
        }
        else {
            params.append(key, value);
        }
    });
    return params.toString() || '';
}
export default DataReferenceQuery;
